import { MEMBER_WANNABE_NAMESPACE } from '@/global/constants/featureFlags'
import { useGetFeatureFlag } from '@/global/hooks'
import { UNIFIED_SIMULATOR_ENDPOINT_FLAG } from '@/modules/simulator/constants'

const useGetUnifiedSimulatorEndpointFlag = () => {
  return useGetFeatureFlag({
    namespace: MEMBER_WANNABE_NAMESPACE,
    key: UNIFIED_SIMULATOR_ENDPOINT_FLAG
  })
}

export { useGetUnifiedSimulatorEndpointFlag }
